<template>
  <div class="">
    <transition-group name="list" tag="div" class="draged_elems">
      <drag
        v-for="n in filtredEvents"
        :data="n"
        class="item"
        :key="n.node.eventId"
        >{{ n.node.distance }} {{ n.node.stroke }}</drag
      >
    </transition-group>
    <!-- <drop-list
      :items="dropped"
      class="main"
      @insert="onInsert"
      @reorder="$event.apply(dropped)"
    >
      <template v-slot:item="{ item }">
        <drag class="item" :key="item.node.eventId"
          >{{ item.node.distance }} {{ item.node.stroke }}</drag
        >
      </template>
      <template v-slot:feedback="{ data }">
        <div class="item feedback" :key="data.node.eventId">
          {{ data.node.distance }} {{ data.node.stroke }}
        </div>
      </template>
    </drop-list> -->
  </div>
</template>

<script>
import { Drag, Drop, DropMask, DropList } from "vue-easy-dnd";
import { mapGetters, mapActions } from "vuex";
export default {
  components: {
    Drag,
    Drop,
    DropMask,
    DropList,
  },
  props: {
     sessionItems: [],
  },
  data() {
    return {
    };
  },
  methods: {
  },
  computed: {
    ...mapGetters(["events", "allSessionEvent"]),
    filtredEvents() {
      let sessionSeqnoIds = this.sessionItems.map(item => item.node.seqno);
      const includes = (arr1, arr2) => arr1.filter(o1 => arr2.map(o2 => {return +o2 === o1.node.sessionSeqno}).includes(true));
      let includesEvents = includes(this.allSessionEvent.edges, sessionSeqnoIds);
      const exclude = (arr1, arr2) => arr1.filter(o1 => arr2.map(o2 => +o2.node.event.eventId).indexOf(+o1.node.eventId) === -1);
       let res = exclude(this.events.edges, includesEvents);
      if(res.lenght === 0) {
        return []
      }
      else {
        return res
      }
    },
  },
};
</script>

<style scope>
.main {
  height: auto;
  background: #ccc;
  display: inline-block;
  width: 100%;
}
.main .item{
  padding: 5px;
}
.element_block {
  background: #fcffce;
  padding: 3px;
  border: 1px solid #dedede;
}
.draged_elems .dnd-drag{
  background: #ececec;
  padding: 3px;
  border: 1px solid #dedede;
  margin: 5px 5px;
  padding: 2px;
}
.draged_elems{
  width: 100%;
  display: flex;
  flex-wrap: wrap;
}
</style>